import { Component, ElementRef, OnDestroy, Optional, ViewChild } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import { SharedService } from '../shareModule/services/shared.service';
import { RecommendationsFormComponent } from '../customers/community/recommandations-form/recommandations-form.component';
import { SignInComponent } from '../customers/layout/component-layout/sign-in/sign-in.component';

@Component({
  selector: 'app-site-promo-popup',
  templateUrl: './site-promo-popup.component.html',
  styleUrl: './site-promo-popup.component.scss'
})
export class SitePromoPopupComponent implements OnDestroy {
  constructor(@Optional()  ngbModalInfoRef: NgbActiveModal, @Optional()  matBottomSheetRef: MatBottomSheetRef,
    private  local:LocalServiceService, private modalService: NgbModal, private bottomSheet: MatBottomSheet, private sharedService: SharedService
  ){
    this.modalInfoRef = ngbModalInfoRef || matBottomSheetRef;
  }
  ngOnDestroy(): void {
    
  }
  public modalInfoRef = null;



  @ViewChild('SignIn', {static: true}) signInModal : SignInComponent;

  private _openLogin(){
    this.signInModal.loginStage = '';
    this.signInModal.openSignInPopup();
 //   this.local.fixModalZIndexes()
  }



  public openRecommend(){
    console.log('called')

    if(!this.local.getUser()){

      this._openLogin()
      const subs = this.local.getUserDetailsObserver().subscribe((user)=>{
        if(user){ 
          this.openRecommend();
          subs.unsubscribe();
        }

      })
      return;
    }
    this.modalInfoRef?.close()
    if (this.sharedService.isOnMobile) {
      this.bottomSheet.open(RecommendationsFormComponent)
    }else{
      this.modalService.open(RecommendationsFormComponent)
    }


  }
  public openReport(){
    console.log('called')

    if(!this.local.getUser()){

      this._openLogin()
      const subs = this.local.getUserDetailsObserver().subscribe((user)=>{
        if(user){ 
          this.openReport();
          subs.unsubscribe();
        }

      })
      return;
    }
    this.modalInfoRef?.close()
    this.local.alertReport()

  }

}
